import { render, staticRenderFns } from "./techprocessesAddWaste.vue?vue&type=template&id=d50b41ae&scoped=true&"
import script from "./techprocessesAddWaste.vue?vue&type=script&lang=js&"
export * from "./techprocessesAddWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50b41ae",
  null
  
)

export default component.exports